import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/change-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/dashboards/change-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard.employee",
    path: `${APP_PREFIX_PATH}/dashboards/employee-dashboard`,
    component: React.lazy(() => import("views/app-views/dashboards/employee-dashboard")),
  },
  {
    key: "dashboard.office",
    path: `${APP_PREFIX_PATH}/dashboards/office`,
    component: React.lazy(() => import("views/app-views/dashboards/office")),
  },

  {
    key: "dashboard.views",
    path: `${APP_PREFIX_PATH}/dashboards/office/detail/:office_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/office/view")
    ),
  },
  {
    key: "dashboard.officetype",
    path: `${APP_PREFIX_PATH}/dashboards/officetype`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/coustomer/customerofficetype")
    ),
  },

  {
    key: "dashboard.department",
    path: `${APP_PREFIX_PATH}/dashboards/department`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/department")
    ),
  },

  {
    key: "dashboard.designation",
    path: `${APP_PREFIX_PATH}/dashboards/designation`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/designation")
    ),
  },
  {
    key: "dashboard.role",
    path: `${APP_PREFIX_PATH}/dashboards/role`,
    component: React.lazy(() => import("views/app-views/dashboards/role")),
  },
  {
    key: "dashboard.rolePermission",
    path: `${APP_PREFIX_PATH}/dashboards/rolesPermission/:role_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/role/permissions")
    ),
  },
  {
    key: "dashboard.permission",
    path: `${APP_PREFIX_PATH}/dashboards/permission`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/permission")
    ),
  },
  {
    key: "dashboard.notifications",
    path: `${APP_PREFIX_PATH}/dashboards/notifications`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/notifications")
    ),
  },
  {
    key: "dashboard.notifications.send",
    path: `${APP_PREFIX_PATH}/dashboards/notifications/send`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/notifications/SendNotification")
    ),
  },
  {
    key: "dashboard.activity-logs",
    path: `${APP_PREFIX_PATH}/dashboards/activity-logs`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/activity-logs")
    ),
  },
  {
    key: "dashboard.user",
    path: `${APP_PREFIX_PATH}/dashboards/user`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/user/components/userlist")
    ),
  },
  {
    key: "dashboard.employee",
    path: `${APP_PREFIX_PATH}/dashboards/employee`,
    component: React.lazy(() => import("views/app-views/dashboards/employe")),
  },
  {
    key: "dashboard.employee.bulk",
    path: `${APP_PREFIX_PATH}/dashboards/employee/bulk-upload`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/employe/bulkupload")
    ),
  },
  {
    key: "dashboard.addemployee",
    path: `${APP_PREFIX_PATH}/dashboards/employee-add`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/employe/EmployeeAdd")
    ),
  },
  {
    key: "dashboard.employeeedit",
    path: `${APP_PREFIX_PATH}/dashboards/employee-edit/:employee_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/employe/EmployeeEdit")
    ),
  },
  {
    key: "dashboard.employeview",
    path: `${APP_PREFIX_PATH}/dashboards/employee-view/:employee_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/employe/views")
    ),
  },
  {
    key: "dashboard.banks",
    path: `${APP_PREFIX_PATH}/dashboards/banks`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/employe/bankdetail")
    ),
  },
  {
    key: "dashboard.employee.addTarget",
    path: `${APP_PREFIX_PATH}/dashboards/employee/addTarget/:employee_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/employe/AddTarget")
    ),
  },
  {
    key: "dashboard.employe.views",
    path: `${APP_PREFIX_PATH}/dashboards/employe/detail/:employee_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/employe/views")
    ),
  },
  {
    key: "dashboard.createtask",
    path: `${APP_PREFIX_PATH}/dashboards/task`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/meeting/components/createtask")
    ),
  },
  {
    key: "dashboard.createtaskView",
    path: `${APP_PREFIX_PATH}/dashboards/createtask/viewTask/:create_task_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/meeting/components/createtask/View")
    ),
  },
  {
    key: "dashboard.orders",
    path: `${APP_PREFIX_PATH}/dashboards/orders`,
    component: React.lazy(() => import("views/app-views/dashboards/orders")),
  },
  {
    key: "dashboard.orders",
    path: `${APP_PREFIX_PATH}/dashboards/orders/customers/:customer_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/orders/customerOrder")
    ),
  },
  {
    key: "dashboard.order-create",
    path: `${APP_PREFIX_PATH}/dashboards/order/create`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/orders/create")
    ),
  },
  {
    key: "dashboard.order-create-customer",
    path: `${APP_PREFIX_PATH}/dashboards/order/create/:customer_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/orders/create")
    ),
  },
  {
    key: "dashboard.order-view",
    path: `${APP_PREFIX_PATH}/dashboards/order/view/:order_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/orders/view")
    ),
  },
  {
    key: "dashboard.order-edit",
    path: `${APP_PREFIX_PATH}/dashboards/order/edit/:order_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/orders/edit")
    ),
  },
  {
    key: "dashboard.leads",
    path: `${APP_PREFIX_PATH}/dashboards/leads`,
    component: React.lazy(() => import("views/app-views/dashboards/leads")),
  },
  {
    key: "dashboard.leads.details",
    path: `${APP_PREFIX_PATH}/dashboards/lead/create`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/leads/create")
    ),
  },
  {
    key: "dashboard.leads.details",
    path: `${APP_PREFIX_PATH}/dashboards/lead/view/:lead_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/leads/view")
    ),
  },
  {
    key: "dashboard.leads.edit",
    path: `${APP_PREFIX_PATH}/dashboards/lead/edit/:lead_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/leads/edit")
    ),
  },
  {
    key: "dashboard.standardMail",
    path: `${APP_PREFIX_PATH}/dashboards/standardMail`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/meeting/components/standardMail")
    ),
  },
  {
    key: "dashboard.standardMailView",
    path: `${APP_PREFIX_PATH}/dashboards/mom/standardMailView/:standerd_mailer_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/meeting/components/standardMail/View")
    ),
  },
  {
    key: "dashboard.kpi",
    path: `${APP_PREFIX_PATH}/dashboards/kpi-view/:kpi_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/kpi/viewkpi")
    ),
  },
  {
    key: "dashboard.kpi",
    path: `${APP_PREFIX_PATH}/dashboards/kpi`,
    component: React.lazy(() => import("views/app-views/dashboards/kpi")),
  },
  {
    key: "dashboard.discountauthority",
    path: `${APP_PREFIX_PATH}/dashboards/discountauthority`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sales/discountauthority")
    ),
  },
  {
    key: "dashboard.pricing",
    path: `${APP_PREFIX_PATH}/dashboards/pricing`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/addpricing")
    ),
  },
  {
    key: "dashboard.pricing.create",
    path: `${APP_PREFIX_PATH}/dashboards/pricing/create`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/addpricing/create")
    ),
  },
  {
    key: "dashboard.pricing.edit",
    path: `${APP_PREFIX_PATH}/dashboards/pricing/edit/:pricing_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/addpricing/create")
    ),
  },
  {
    key: "dashboard.pricing",
    path: `${APP_PREFIX_PATH}/dashboards/product/pricing/import`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/addpricing/importPrice")
    ),
  },
  {
    key: "dashboard.pricing",
    path: `${APP_PREFIX_PATH}/dashboards/product/pricing/import/texture`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/addpricing/importTexture")
    ),
  },
  {
    key: "dashboard.pricing.views",
    path: `${APP_PREFIX_PATH}/dashboards/pricing/detail/:pricing_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/addpricing/view")
    ),
  },
  {
    key: "dashboard.product",
    path: `${APP_PREFIX_PATH}/dashboards/product`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/products")
    ),
  },
  {
    key: "dashboard.design",
    path: `${APP_PREFIX_PATH}/dashboards/design`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/design")
    ),
  },
  {
    key: "dashboard.design.design",
    path: `${APP_PREFIX_PATH}/dashboards/design/create`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/design/create")
    ),
  },
  {
    key: "dashboard.design.import",
    path: `${APP_PREFIX_PATH}/dashboards/design/import`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/design/importFile")
    ),
  },
  {
    key: "dashboard.product.design-edit",
    path: `${APP_PREFIX_PATH}/dashboards/design/edit/:design_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/design/edit")
    ),
  },
  {
    key: "dashboard.product.design-view",
    path: `${APP_PREFIX_PATH}/dashboards/design/detail/:design_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/design/view")
    ),
  },
  {
    key: "dashboard.stock",
    path: `${APP_PREFIX_PATH}/dashboards/stock`,
    component: React.lazy(() => import("views/app-views/dashboards/stock")),
  },
  {
    key: "dashboard.stock-add",
    path: `${APP_PREFIX_PATH}/dashboards/stock/add`,
    component: React.lazy(() => import("views/app-views/dashboards/stock/add")),
  },
  {
    key: "dashboard.expense",
    path: `${APP_PREFIX_PATH}/dashboards/expense`,
    component: React.lazy(() => import("views/app-views/dashboards/expense")),
  },
  {
    key: "dashboard.hrms",
    path: `${APP_PREFIX_PATH}/dashboards/leaves`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/leave")
    ),
  },
  {
    key: "dashboard.hrms",
    path: `${APP_PREFIX_PATH}/dashboards/employee-leaves`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/employeleave/userleavelist")
    ),
  },
  {
    key: "dashboard.hrms",
    path: `${APP_PREFIX_PATH}/dashboards/employee/leaves`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/employeleave")
    ),
  },
  {
    key: "dashboard.hrms",
    path: `${APP_PREFIX_PATH}/dashboards/employee/leaves/:employee_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/employeleave")
    ),
  },
  {
    key: "dashboard.hrms",
    path: `${APP_PREFIX_PATH}/dashboards/holiday`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/holiday")
    ),
  },
  {
    key: "dashboard.shift",
    path: `${APP_PREFIX_PATH}/dashboards/shift`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/shift")
    ),
  },
  {
    key: "dashboard.hrms.salary",
    path: `${APP_PREFIX_PATH}/dashboards/salary`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/salary")
    ),
  },
  {
    key: "dashboard.hrms.emp.salary",
    path: `${APP_PREFIX_PATH}/dashboards/salary/:employee_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/salary/emplyeeSalary")
    ),
  },
  {
    key: "dashboard.emp.salary",
    path: `${APP_PREFIX_PATH}/dashboards/salary/employee`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/salary/emplyeeSalary")
    ),
  },
  {
    key: "dashboard.earingStatements",
    path: `${APP_PREFIX_PATH}/dashboards/earning-statement`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/earningstatement")
    ),
  },
  {
    key: "dashboard.earingStatementsform",
    path: `${APP_PREFIX_PATH}/dashboards/earning-statement-form/:employee_id`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/hrms/earningSalaryStatement/earningStatementForm"
      )
    ),
  },
  {
    key: "dashboard.earingStatement",
    path: `${APP_PREFIX_PATH}/dashboards/add-earning-statement/:employee_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/earningSalaryStatement/index")
    ),
  },
  {
    key: "dashboard.attendance",
    path: `${APP_PREFIX_PATH}/dashboards/attendance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/attendence")
    ),
  },
  {
    key: "dashboard.attendance-missed-punch",
    path: `${APP_PREFIX_PATH}/dashboards/attendance/missed-punch`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/attendence/missedPunchReport")
    ),
  },
  {
    key: "dashboard.advance.payment",
    path: `${APP_PREFIX_PATH}/dashboards/advance-payment`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/advancePayment")
    ),
  },
  {
    key: "dashboard.advance.payment.bulk",
    path: `${APP_PREFIX_PATH}/dashboards/advance-payment/bulk-upload`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/hrms/advancePayment/bulkupload")
    ),
  },
  {
    key: "dashboard.employeeattendance",
    path: `${APP_PREFIX_PATH}/dashboards/attendance/:employee_id`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/hrms/attendence/employeeattendancecalendar"
      )
    ),
  },
  {
    key: "dashboard.working.days",
    path: `${APP_PREFIX_PATH}/dashboards/working-days`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/workingDays")
    ),
  },
  {
    key: "dashboard.ticket",
    path: `${APP_PREFIX_PATH}/dashboards/ticket`,
    component: React.lazy(() => import("views/app-views/dashboards/ticket")),
  },
  {
    key: "dashboard.ticket-show",
    path: `${APP_PREFIX_PATH}/dashboards/ticket/view/:ticket_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ticket/show")
    ),
  },
  {
    key: "dashboard.production",
    path: `${APP_PREFIX_PATH}/dashboards/production`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production")
    ),
  },
  {
    key: "dashboard.production.completed",
    path: `${APP_PREFIX_PATH}/dashboards/production/completed`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production")
    ),
  },
  {
    key: "dashboard.production.add",
    path: `${APP_PREFIX_PATH}/dashboards/production/add`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/add")
    ),
  },
  {
    key: "dashboard.production.add",
    path: `${APP_PREFIX_PATH}/dashboards/production/details/:production_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/details")
    ),
  },
  {
    key: "dashboard.production.stage",
    path: `${APP_PREFIX_PATH}/dashboards/production/stage`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/stage")
    ),
  },
  {
    key: "dashboard.production.category.stage",
    path: `${APP_PREFIX_PATH}/dashboards/production/category-stage`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/categorystage")
    ),
  },
  {
    key: "dashboard.production.area",
    path: `${APP_PREFIX_PATH}/dashboards/allotted-area`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/area")
    ),
  },
  {
    key: "dashboard.production.area",
    path: `${APP_PREFIX_PATH}/dashboards/area/report/:area_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/areaReport")
    ),
  },
  {
    key: "dashboard.production.screens",
    path: `${APP_PREFIX_PATH}/dashboards/production-setup/screens`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/screens")
    ),
  },
  {
    key: "dashboard.production.screens.create",
    path: `${APP_PREFIX_PATH}/dashboards/production-setup/screens/create`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/screens/form")
    ),
  },
  {
    key: "dashboard.production.screens.view",
    path: `${APP_PREFIX_PATH}/dashboards/production-setup/screens/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/screens/view")
    ),
  },
  {
    key: "dashboard.production.screens.edit",
    path: `${APP_PREFIX_PATH}/dashboards/production-setup/screens/:id/edit`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/production/screens/form")
    ),
  },
  {
    key: "dashboard.category",
    path: `${APP_PREFIX_PATH}/dashboards/category`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/category")
    ),
  },
  {
    key: "dashboard.subcategory",
    path: `${APP_PREFIX_PATH}/dashboards/subCategory/:category_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/category/subcategory")
    ),
  },
  {
    key: "dashboard.size",
    path: `${APP_PREFIX_PATH}/dashboards/size`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/size")
    ),
  },
  {
    key: "dashboard.product-creation",
    path: `${APP_PREFIX_PATH}/dashboards/product-creation`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/productDesign")
    ),
  },
  {
    key: "dashboard.product-creation-create",
    path: `${APP_PREFIX_PATH}/dashboards/product-creation-create`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/product/productDesign/create")
    ),
  },
  {
    key: "dashboard.order-stage",
    path: `${APP_PREFIX_PATH}/dashboards/production-stage/:type`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sales/salesStatus")
    ),
  },
  {
    key: "dashboard.lead-stage",
    path: `${APP_PREFIX_PATH}/dashboards/lead-stage/:type`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sales/salesStatus")
    ),
  },
  {
    key: "dashboard.lead-product",
    path: `${APP_PREFIX_PATH}/dashboards/product-stage/:type`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sales/salesStatus")
    ),
  },
  {
    key: "dashboard.orderProp",
    path: `${APP_PREFIX_PATH}/dashboards/order-probability`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sales/orderprop")
    ),
  },
  {
    key: "dashboard.mom",
    path: `${APP_PREFIX_PATH}/dashboards/mom`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/meeting/components/mom")
    ),
  },
  {
    key: "dashboard.momView",
    path: `${APP_PREFIX_PATH}/dashboards/mom/viewMom/:mom_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/meeting/components/mom/View")
    ),
  },
  {
    key: "dashboard.visitscheduling",
    path: `${APP_PREFIX_PATH}/dashboards/visitscheduling`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/meeting/components/visitscheduling")
    ),
  },
  {
    key: "dashboard.visitschedulingView",
    path: `${APP_PREFIX_PATH}/dashboards/visitscheduling/viewvisitscheduling/:visit_scheduling_id`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/meeting/components/visitscheduling/View"
      )
    ),
  },
  {
    key: "dashboard.customers",
    path: `${APP_PREFIX_PATH}/dashboards/customers`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/coustomer/customeraccountcreations")
    ),
  },
  {
    key: "dashboard.customeraccountcreations.import",
    path: `${APP_PREFIX_PATH}/dashboards/customers/importfile`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/coustomer/customeraccountcreations/ImportFile"
      )
    ),
  },
  {
    key: "dashboard.customeraccountcreations.views",
    path: `${APP_PREFIX_PATH}/dashboards/customeraccountcreations/details/:customer_id`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/coustomer/customeraccountcreations/view"
      )
    ),
  },
  {
    key: "dashboard.payment",
    path: `${APP_PREFIX_PATH}/dashboards/payment`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/PaymentandDelivery/payment")
    ),
  },
  {
    key: "dashboard.delivery",
    path: `${APP_PREFIX_PATH}/dashboards/delivery`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/PaymentandDelivery/delivery")
    ),
  },
  {
    key: "dashboard.offerCreation",
    path: `${APP_PREFIX_PATH}/dashboards/offerCreation`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/offerCreation")
    ),
  },
  {
    key: "dashboard.offerCreation.addDetails",
    path: `${APP_PREFIX_PATH}/dashboards/offer/create`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/offerCreation/add")
    ),
  },
  {
    key: "dashboard.offerCreation.edit",
    path: `${APP_PREFIX_PATH}/dashboards/offer/edit/:offer_creation_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/offerCreation/edit")
    ),
  },
  {
    key: "dashboard.offerCreation.views",
    path: `${APP_PREFIX_PATH}/dashboards/offerCreation/details/:offer_creation_id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/offerCreation/viewoffer")
    ),
  },
];
